import React, { useMemo } from 'react';
import { TableContainer, Card, Grid, CardContent } from '@mui/material';
import { Report } from '../../../models/ReportData';
import {
  buildAccountsTable,
  getVisibleColumnTypes,
  getBreakdownRowKeys,
} from '../../../data/report/helpers/userAccountsUtils';
import BreakdownHeader from './BreakdownHeader';
import CondensedTableView from './CondensedTableView';
import ReportTableHeader from './ReportTableHeader';

interface BreakdownTableProps {
  report: Report;
}

const BreakdownTable: React.FC<BreakdownTableProps> = ({ report }) => {
  const data = useMemo(() => buildAccountsTable(report), [report]);
  const columns = useMemo(() => getVisibleColumnTypes(data), [data]);
  const rows = useMemo(() => getBreakdownRowKeys(), []);
  const reportName = 'name' in report && typeof report.name === 'string' ? report.name : undefined;

  return (
    <Grid container mb={3}>
      <Card variant='ghost' color='primary'>
        <CardContent>
          <TableContainer>
            <Grid px={2}>
              <ReportTableHeader
                columns={columns}
                leftContent={
                  <BreakdownHeader
                    reportName={reportName}
                    activeUserCount={data.Total?.activeUserCount || 0}
                  />
                }
              />
              <CondensedTableView rows={rows} columns={columns} data={data} />
            </Grid>
          </TableContainer>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default BreakdownTable;
